import { GameServices } from '../../services/game-services';
import { GridViewModel } from '../grid/grid-view-model';
import { LoadingGridViewModel } from '../loading/loading-grid-view-model';
import { ShapeBoardViewModel } from '../shape/shape-board-view-model';
import { LevelControlViewModel } from './level-control-view-model';
import { LevelViewModel } from './level-view-model';
import { MultiplierControlViewModel } from './multiplier-control-view-model';
import { StartViewModel } from './start-view-model';

export class BoardViewModel {
  public readonly loadingGridViewModel: LoadingGridViewModel;
  public readonly gridViewModel: GridViewModel;
  public readonly shapeBoardViewModel: ShapeBoardViewModel;
  public readonly multiplierControlViewModel: MultiplierControlViewModel;
  public readonly levelControlViewModel: LevelControlViewModel;
  public readonly levelViewModel: LevelViewModel;
  public readonly startViewModel: StartViewModel;

  constructor(gameServices: GameServices) {
    this.loadingGridViewModel = new LoadingGridViewModel(gameServices);
    this.gridViewModel = new GridViewModel(gameServices);
    this.shapeBoardViewModel = new ShapeBoardViewModel(gameServices);
    this.multiplierControlViewModel = new MultiplierControlViewModel(gameServices);
    this.levelControlViewModel = new LevelControlViewModel(gameServices);
    this.levelViewModel = new LevelViewModel(gameServices);
    this.startViewModel = new StartViewModel(gameServices);
  }

  public showStartButton(showButton: boolean) {
    this.startViewModel.showStartButton(showButton);
  }

  public resetGameScene() {
    this.loadingGridViewModel.resetGameScene();
    this.gridViewModel.resetGameScene();
    this.shapeBoardViewModel.resetGameScene();
    this.multiplierControlViewModel.resetGameScene();
    this.levelControlViewModel.resetGameScene();
    this.levelViewModel.resetGameScene();
  }
}
